<template>
  <div class="flex">
    <p
      :class="`text-center text-[12px] font-medium rounded-full py-[2px] px-[8px] border-[1px] m-0`"
      :style="{ backgroundColor: mappedStatus.bgColor, color: mappedStatus.color, borderColor: mappedStatus.color }"
    >{{ mappedStatus.label }}</p>
  </div>
</template>

<script>
import { statusMapping } from './config'

/**
 * InboundStatusPill component
 * @description This component is used to display the inbound status pill with preconfigured status mapping.
 */
export default {
  name: 'InboundStatusPill',
  props: {
    value: {
      type: String,
      default: 'unknown',
    },
  },
  computed: {
    mappedStatus() {
      const status = statusMapping[this.value]

      if (status) {
        return status
      }

      return statusMapping.unknown
    },
  },
}
</script>
